import { EmailTemplateList } from '@dealstack/frontend/shared/components/EmailTemplates/components/EmailTemplateList';
import { StyledEmailTemplatesContainer } from '@dealstack/frontend/shared/components/EmailTemplates/styles';
import { EmailTemplateScopeKind } from '@dealstack/frontend/shared/components/EmailTemplates/EmailTemplates.types';
import { DEAL_ROUTES, ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { useBreadcrumbs } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs';
import {
	useTranslationAdminDashboard,
	useTranslationCommonUi,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useMemo } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';

interface Props {
	dealId: string;
}

export const DealEmailTemplates = ({ dealId }: Props) => {
	const navigate = useNavigate();
	const tCommonUi = useTranslationCommonUi();
	const tAdminDashboard = useTranslationAdminDashboard();
	const scope = useMemo(() => ({ kind: EmailTemplateScopeKind.DEAL, id: dealId }), [dealId]);

	useBreadcrumbs([
		{
			name: tCommonUi('breadcrumbs.deal_settings'),
			url: generatePath(`${ROUTES.DEAL}${DEAL_ROUTES.SETTINGS}`, { dealId }),
		},
		{
			name: tAdminDashboard('deal_settings.labels.email_templates', {
				defaultValue: 'Email templates',
			}),
			url: '',
			noLink: true,
		},
	]);

	return (
		<StyledEmailTemplatesContainer>
			<EmailTemplateList scope={scope} onEdit={(templateType) => navigate(templateType)} />
		</StyledEmailTemplatesContainer>
	);
};
